export const WEB_BOOKING_TABS = [
    { id: 'new', label: 'New Requests', icon: 'bi-bell', status: 0 },
    { id: 'followup', label: 'Follow Up', icon: 'bi-clock-history', status: 1 },
    { id: 'processed', label: 'Processed', icon: 'bi-check2-circle', status: 2 },
    { id: 'all', label: 'All Requests', icon: 'bi-card-list', status: 5 },
];

export const WEB_BOOKING_SEARCH_COLUMNS = [
    { value: 'firstName', label: 'First Name' },
    { value: 'lastName', label: 'Last Name' },
    { value: 'preferredName', label: 'Preferred Name' },
    { value: 'cellPhone', label: 'Cell Phone' },
    { value: 'homePhone', label: 'Home Phone' },
    { value: 'email', label: 'Email' },
];

export const DEFAULT_WEB_BOOKING_SEARCH = {
    column: 'firstName',
    value: '',
};

export const formatBookingDate = (dateString) => {
    if (!dateString) {
        return '—';
    }

    return new Date(dateString).toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

export const formatBookingDateTime = (dateString) => {
    if (!dateString) {
        return '—';
    }

    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const getPatientInitials = (firstName = '', lastName = '') =>
    `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`.toUpperCase() || '?';

export const getBookingStatusMeta = (status) => {
    const config = {
        0: { className: 'web-bookings-status web-bookings-status--new', icon: 'bi-bell', label: 'New' },
        1: { className: 'web-bookings-status web-bookings-status--followup', icon: 'bi-clock-history', label: 'Follow Up' },
        2: { className: 'web-bookings-status web-bookings-status--processed', icon: 'bi-check2-circle', label: 'Processed' },
    };

    return config[status] || config[0];
};

export const getPatientTypeMeta = (isNewPatient) =>
    isNewPatient
        ? { className: 'web-bookings-patient-type web-bookings-patient-type--new', label: 'New Patient' }
        : { className: 'web-bookings-patient-type web-bookings-patient-type--existing', label: 'Existing Patient' };

export const buildBookingRequestParams = (bookingStatus, search) => ({
    status: bookingStatus,
    ...(search.value?.trim()
        ? { column: search.column, value: search.value.trim() }
        : {}),
});

/** @deprecated Use buildBookingRequestParams with bookingService.getBookingRequests */
export const buildBookingSearchQuery = (bookingStatus, search) => {
    const params = buildBookingRequestParams(bookingStatus, search);
    const query = new URLSearchParams({ status: String(params.status) });

    if (params.column && params.value) {
        query.set('column', params.column);
        query.set('value', params.value);
    }

    return query.toString();
};
